module.exports = __webpack_public_path__ + "static/media/washington-nationals-logo.9c331163.svg";